import Block from './Block'

export default class Contact extends Block {
  onEnterCompleted() {
    super.onEnterCompleted()

    setTimeout(() => {
      this.render()
    }, 500);
  }

  getElems() {
    super.getElems()
    this.$SubmitButton = this.el.querySelector('button')
    this.$captcha = this.el.querySelector('.ginput_recaptcha')
  }

  events() {
    super.events()
    this.$SubmitButton.addEventListener('click', () => {
      this.$SubmitButton.classList.add('disabled')
    })
  }

  render() {
    grecaptcha.render(this.$captcha)
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Contact.js